module.exports = __webpack_public_path__ + "static/media/n25.b07d3ce2.jpg";